import { NgGridStackWidget } from 'gridstack/dist/angular';

export interface Layout {
    name: string;
    display: NgGridStackWidget[];
}

export interface LayoutRepository<T> {
    addLayout(layout: T): boolean;
    deleteLayout(name: string): boolean;
    updateLayout(layout: T): boolean;
    findLayout(name: string): T;
}

/** ReportTypeEnum is the set of valid values for all the report types defined in the platform. */
export enum ReportTypeEnum {
    Dataminer = 'DATAMINER',
    MarketOverview = 'MARKET_OVERVIEW',
    MtReport = 'MT_REPORT'
}

/**valid id for the mediatools planning report. This should go away if we have more reports and handled accordingly */
export const MT_REPORT_TYPE_ID = '1';
